import { Yield } from '../../abacus/interfaces/yield.interface'

export const impactedStakeholderYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
